export const routes = {
  home: "/",
  ean: ":ean",
  certificateId: ":certificateId",
  products: "/products",
  certificates: "/certificates",
  contact: "/contact",
  partner: "/partner",
  login: "/login",
  cart: "/cart",
  passwordChange: "/password-change",
  passwordReset: "/password-reset"
};

export const Anchors = {
  news: "news",
  preparing: "preparing",
  aboutUs: "about-us",
  showroom: "showroom"
};

/**
 * Absolute URL for direct certificate access (used as the QR code target). Certificates are
 * addressed by their own id — a single EAN can cover several certificates, so it does not
 * identify one. When no language is given the URL points at the certificate itself, letting
 * the visitor pick the language on arrival.
 */
export const certificateDirectUrl = (certificateId: number, language?: string) =>
  `${window.location.origin}${routes.certificates}/${certificateId}${
    language ? `/${language}` : ""
  }`;
